import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages";
import './global.scss';
import "./CustomScrollbar.css";
import './i18n';

function App() {

  
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
          </Route>
          <Route path="/en">
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
